import { render, staticRenderFns } from "./PlanSeats.vue?vue&type=template&id=58807630&"
import script from "./PlanSeats.vue?vue&type=script&lang=js&"
export * from "./PlanSeats.vue?vue&type=script&lang=js&"
import style0 from "./PlanSeats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports